
import {
	ArrayFilter,
	ComparableType,
	restoreFilters,
	saveFilters,
	STRING_COMPARISON_OPERATORS,
	useArrayFilters,
} from "@/hooks/useArrayFilters";
import { regexWatcherService } from "@/services/regexWatcherService";
import { Result } from "@/services/watcherService";
import { computed, defineComponent, ref, watch } from "vue";
import ColumnFilterDropdown, {
	NewArrayFilter,
} from "./ColumnFilterDropdown.vue";
import RegexResultRow from "./RegexResultRow.vue";

export default defineComponent({
	components: { RegexResultRow, ColumnFilterDropdown },
	setup() {
		const {
			regexes,
			regexResults,
			addNewRegex,
			removeRegex,
			setRegexEnabled,
		} = regexWatcherService;

		const emptyRegex = { name: "", regex: "" };
		const newRegex = ref({ ...emptyRegex });
		const handleAddNewRegex = () => {
			addNewRegex(newRegex.value.regex, newRegex.value.name);
			newRegex.value = { ...emptyRegex };
		};

		// result filters
		const filterOptions = [
			{
				value: "matched",
				title: "Matched",
				comparisonOperators: STRING_COMPARISON_OPERATORS,
			},
			{
				value: "name",
				title: "Name",
				comparisonOperators: STRING_COMPARISON_OPERATORS,
			},
		];

		// override filters getters for custom fields
		const {
			filters,
			addFilter,
			deleteFilter,
			applyFilters,
			setFilterEnabled,
		} = useArrayFilters();
		const filterGetterOverrides: Record<string, ArrayFilter["getter"]> = {
			duration: (result: Result) => result.durationMS / 1000,
		};
		const getGetterForKey = (key: string) =>
			filterGetterOverrides[key] ||
			((result: Result) => {
				const value = result[
					key as keyof Result
				] as ComparableType | null;
				return value === null ? "" : value;
			});
		const handleAddFilter = (newFilter: NewArrayFilter) => {
			const getter = getGetterForKey(newFilter.key);
			addFilter({
				...newFilter,
				getter,
				enabled: newFilter.enabled ?? true,
			});
		};

		// save/restore filters from localStorage
		for (const filter of restoreFilters("regexesFilters")) {
			handleAddFilter(filter);
		}
		watch(filters.value, (newFilters: ArrayFilter[]) => {
			saveFilters(newFilters, "regexesFilters");
		});

		// filter results
		const filteredResults = computed(() =>
			applyFilters(regexResults.value, filters.value)
		);

		return {
			regexes,
			results: filteredResults,

			newRegex,
			handleAddNewRegex,
			removeRegex,

			setRegexEnabled,

			filters,
			filterOptions,
			handleAddFilter,
			deleteFilter,
			setFilterEnabled,
		};
	},
});
